
import $ from 'jquery';
import Hammer from 'hammerjs';

import 'intersection-observer';

import debounce from './util/debounce';
import globals from './global/globals';
import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        autoplay: true,
        autoplayDelay: 5000,
        transitionSpeed: globals.anim.transitionSpeed,

        slideshowSelector: '.slideshow',
        trackSelector: '.slideshow__track',
        slideSelector: '.slideshow__slide',

        currentIndexSelector: '.slideshow__index__current',

        prevSelector: '.slideshow__prev',
        nextSelector: '.slideshow__next',
        pauseSelector: '.slideshow__pause',

        captionSelector: '.slideshow__caption',

        devMode: true
    }, options);


    var ele = $.extend({
        slideshows: $(o.slideshowSelector)
    }, globalelements);


    var intrn = {
        name: 'Slideshow',
        slideshow: null,
        slideshowObserver: null
    };


    var fn = {
        init: function () {
            if (ele.slideshows.length < 1) return;

            intrn.slideshowObserver = new window.IntersectionObserver(handlers.slideshowObserver);

            fn.setupSlideshows();

            globalelements.win.on('resize', debounce(handlers.resize, 100));
        },

        setupSlideshows: function () {
            ele.slideshows.each(function (i) {
                var sldshw = $(this);

                sldshw.data('num', i);
                sldshw.data('index', 0);
                sldshw.data('track', sldshw.find(o.trackSelector));
                sldshw.data('slides', sldshw.find(o.slideSelector));
                sldshw.data('indexDisplay', sldshw.find(o.currentIndexSelector));
                sldshw.data('captions', sldshw.find(o.captionSelector));
                sldshw.data('slideCount', sldshw.data('slides').length);
                sldshw.data('slideWidth', sldshw.data('slides').first().outerWidth());

                sldshw.data('hammer', new Hammer(sldshw[0]));

                sldshw.data('hammer').on('swipe', function (e) {
                    if (e.direction === 4) {
                        fn.prevSlide(sldshw);
                    } else if (e.direction === 2) {
                        fn.nextSlide(sldshw);
                    }
                });

                sldshw.find(o.prevSelector).on('click', function () {
                    fn.prevSlide(sldshw);
                    fn.pause(sldshw);
                });
                sldshw.find(o.nextSelector).on('click', function () {
                    fn.nextSlide(sldshw);
                    fn.pause(sldshw);
                });

                sldshw.find(o.pauseSelector).on('click', function () {
                    if (!sldshw.data('playing')) {
                        fn.autoplay(sldshw);
                    } else {
                        fn.pause(sldshw);
                    }
                });

                intrn.slideshowObserver.observe(sldshw[0]);
            });
        },
        resizeSlideshows: function () {
            ele.slideshows.each(function () {
                var sldshw = $(this);

                sldshw.data('slideWidth', sldshw.data('slides').first().outerWidth());

                fn.gotoSlide(sldshw, sldshw.data('index'));
            });
        },

        autoplay: function (sldshw) {
            if (!o.autoplay) return;
            if (sldshw.data('playing')) return;

            sldshw.attr('data-paused', 'false');

            sldshw.data('playing', true);
            sldshw.data('timeout', setTimeout(function () {
                fn.nextSlide(sldshw);
            }, o.autoplayDelay));
        },
        pause: function (sldshw) {
            clearTimeout(sldshw.data('timeout'));
            sldshw.attr('data-paused', 'true');
            sldshw.data('playing', false);
        },

        nextSlide: function (sldshw) {
            var count = sldshw.data('slideCount');
            var target = sldshw.data('index') + 1;

            target = (target % count + count) % count;

            fn.gotoSlide(sldshw, target);
        },
        prevSlide: function (sldshw) {
            var count = sldshw.data('slideCount');
            var target = sldshw.data('index') - 1;

            target = (target % count + count) % count;

            fn.gotoSlide(sldshw, target);
        },
        gotoSlide: function (sldshw, slideIndex) {
            clearTimeout(sldshw.data('timeout'));
            sldshw.data('playing', false);
            sldshw.data('index', slideIndex);

            fn.console([
                '~slideshow ' + sldshw.data('num') + '~',
                'going to *slide ' + slideIndex + '*'
            ]);

            var offset = -1 * slideIndex * sldshw.data('slideWidth');
            sldshw.data('track').css('transform', 'translate3d(' + offset + 'px, 0, 0)');

            sldshw.data('indexDisplay').text(slideIndex + 1);
            sldshw.data('captions')
                .removeClass(globals.classes.state.active)
                .eq(slideIndex)
                .addClass(globals.classes.state.active);

            fn.autoplay(sldshw);
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: intrn.name + '.js',
                prefixColor: 'magenta'
            });
        }
    };


    var handlers = {
        resize: function () {
            fn.resizeSlideshows();
        },
        slideshowObserver: function (entries) {
            $.each(entries, function (i, entry) {
                var sldshw = $(entry.target);

                if (entry.isIntersecting) {
                    fn.console([
                        '~slideshow ' + sldshw.data('num') + '~',
                        'starting autoplay'
                    ]);
                    fn.autoplay(sldshw);
                } else if (sldshw.data('playing')) {
                    fn.console([
                        '~slideshow ' + sldshw.data('num') + '~',
                        'pausing'
                    ]);
                    fn.pause(sldshw);
                }
            });
        }
    };


    fn.init();
}
